import angular from 'angular';
import Logger from '../../../shared/logger';

export const StatsService = (Restangular) => {
    const getActiveClaimedJobs = function () {
        return Restangular.all('stats')
            .all('positions')
            .all('status')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getActiveUsers = function () {
        return Restangular.all('stats')
            .all('users')
            .all('active')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getOnlineUsers = function () {
        return Restangular.all('stats')
            .all('users')
            .all('online')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getActiveByTimeFramePositions = function (data) {
        return Restangular.all('stats')
            .all('positions')
            .all('activatedByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getNewByTimeFramePositions = function (data) {
        return Restangular.all('stats')
            .all('positions')
            .all('activeByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getByTimeFrameNumberOfHires = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('numberOfHiresByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getByTimeFrameEmployerActivitySnapshot = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('employersActivitySnapshotByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getByTimeFrameRecruiterActivitySnapshot = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('recruitersActivitySnapshotByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getByTimeFrameAverageTimeToHire = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('averageTimeToHireByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getNewEmployersByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('employers')
            .all('newByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getActiveByTimeFrameEmployers = function (data) {
        return Restangular.all('stats')
            .all('employers')
            .all('activeByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getBusinessKpi = function () {
        return Restangular.all('business')
            .all('kpi')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getConversionKpiByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('conversionKPIByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getHiringFunnelByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('hiringFunnelByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getProcessAnalysis = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('processAnalysis')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getTalentExpertSourcingProductivityByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('talentExpertSourcingProductivityByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getPositionsInProcessByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('positionsInProcessByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getpositionsInAdvancedProcessByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('positionsInAdvancedProcessByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getWorkflowTimeline = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('timeline')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getProfilesSentByTimeFrame = function (data) {
        return Restangular.all('stats')
            .all('workflows')
            .all('profilesSentByTimeFrame')
            .post(data)
            .catch(error => Logger.error(error));
    };

    return {
        getActiveClaimedJobs,
        getActiveUsers,
        getOnlineUsers,
        getActiveByTimeFramePositions,
        getNewByTimeFramePositions,
        getByTimeFrameNumberOfHires,
        getByTimeFrameEmployerActivitySnapshot,
        getByTimeFrameRecruiterActivitySnapshot,
        getByTimeFrameAverageTimeToHire,
        getActiveByTimeFrameEmployers,
        getNewEmployersByTimeFrame,
        getBusinessKpi,
        getConversionKpiByTimeFrame,
        getHiringFunnelByTimeFrame,
        getProcessAnalysis,
        getTalentExpertSourcingProductivityByTimeFrame,
        getPositionsInProcessByTimeFrame,
        getpositionsInAdvancedProcessByTimeFrame,
        getWorkflowTimeline,
        getProfilesSentByTimeFrame,
    };
};

angular
    .module('TALENYA-FE')
    .factory('StatsService', StatsService);

